/**
 * Rotas permitidas para places e eventos expirados (isExpired = true)
 * Quando um place está expirado, apenas rotas de analytics/relatórios são permitidas
 */

/**
 * Rotas relativas permitidas para places expirados
 * Essas rotas são concatenadas com `/place/:placeId`
 */
export const ALLOWED_PLACE_ROUTES_WHEN_EXPIRED = [
	"",
	"/business-intelligence",
	"/financial-report",
	"/bar-reports",
	"/table-reports",
	"/entrance-reports",
	"/invoices-iva",
	"/invoices-national",
	"/invoices-backups",
	"/emission-errors",
	"/missing-invoices",
	"/trasactions",
	"/recharges",
	"/emited",
	"/not-emited-products",
];

/**
 * Rotas relativas permitidas para eventos de places expirados
 * Essas rotas são concatenadas com `/place/:placeId/event/:eventId`
 */
export const ALLOWED_EVENT_ROUTES_WHEN_EXPIRED = [
	"",
	"/clients",
	"/reports",
	"/zig-tags",
	"/recharge-management",
];

/**
 * Verifica se uma rota específica de place é permitida quando o place está expirado
 * @param placeId - ID do place
 * @param pathname - Pathname completo da rota
 * @returns true se a rota é permitida, false caso contrário
 */
export function isPlaceRouteAllowedWhenExpired(
	placeId: string,
	pathname: string,
): boolean {
	const pathWithoutHash = pathname.split("#")[0];
	const pathWithoutQuery = pathWithoutHash.split("?")[0];
	const normalizedPath = pathWithoutQuery.replace(/\/$/, "");

	return ALLOWED_PLACE_ROUTES_WHEN_EXPIRED.some(allowedRoute => {
		const fullPath = `/place/${placeId}${allowedRoute}`;
		const normalizedAllowedPath = fullPath.replace(/\/$/, "");
		return normalizedPath === normalizedAllowedPath;
	});
}

/**
 * Verifica se uma rota específica de evento é permitida quando o place está expirado
 * @param placeId - ID do place
 * @param eventId - ID do evento
 * @param pathname - Pathname completo da rota
 * @returns true se a rota é permitida, false caso contrário
 */
export function isEventRouteAllowedWhenExpired(
	placeId: string,
	eventId: string,
	pathname: string,
): boolean {
	const pathWithoutHash = pathname.split("#")[0];
	const pathWithoutQuery = pathWithoutHash.split("?")[0];
	const normalizedPath = pathWithoutQuery.replace(/\/$/, "");

	return ALLOWED_EVENT_ROUTES_WHEN_EXPIRED.some(allowedRoute => {
		const fullPath = `/place/${placeId}/event/${eventId}${allowedRoute}`;
		const normalizedAllowedPath = fullPath.replace(/\/$/, "");
		return normalizedPath === normalizedAllowedPath;
	});
}
